module.exports = __webpack_public_path__ + "static/media/aspect.a669182b.jpg";